import BulkUploadSuccessState from './BulkUploadSuccessState';
import BulkUploadErrorState from './BulkUploadErrorState';
import {useDispatch, useSelector} from 'react-redux';
import {setDrawer, setFixErrorTab} from '../../redux/slices/bulkUserEditSlice';
import {setAddUserModal} from '../../redux/slices/unSaveChangesModalSlice';
import {RootState} from '../../redux/store';
import {useAnalytics} from '../../hooks/useAnalytics';
import {t} from 'i18next';
import {
  GA_EVENT_NAMES,
  GA_CLICK_TYPES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../constants/analyticsConstants';

const BulkUserUploadState = () => {
  const summaryState = useSelector(
    (state: RootState) => state.bulkUserEdit.summary
  );

  const successCount = summaryState?.totalSuccessUsers ?? 0;
  const errorCount = summaryState?.totalErrorUsers ?? 0;

  const totalErrorCount = summaryState?.totalErrors ?? 0;

  const dispatch = useDispatch();
  const {trackGAEvent} = useAnalytics();
  const handleAddUsersClick = () => {
    if (successCount === 0)
      return; // Button is inactive when no users are added successfully
    else {
      dispatch(setAddUserModal(true));
      trackGAEvent({
        eventName: GA_EVENT_NAMES.CLICK,
        click: {
          name: t('gaTracking.users.addTeamMembers', {count: successCount}),
          type: GA_CLICK_TYPES.BUTTON,
          region: GA_REGIONS.BODY,
          action: t('gaTracking.users.addTeamMemberAction', {
            successCount: successCount,
            totalCount: Number(successCount) + Number(errorCount),
          }),
          details:
            errorCount === 0
              ? t('gaTracking.users.successful')
              : t('gaTracking.users.partialSuccessful'),
        },
      });
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.users.addSubpage', {
            successCount: successCount,
            totalCount: Number(successCount) + Number(errorCount),
          }),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
    }
  };

  const onFixErrorClick = () => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.users.fixErrors'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('gaTracking.users.groupMemberFileErrorFix'),
      },
    });
    if (errorCount > 0) {
      dispatch(setFixErrorTab(true));
    } else {
      dispatch(setDrawer(false));
    }
  };

  return (
    <div className="useruploadstate" data-testid="popup-dialog">
      <BulkUploadErrorState
        errorCount={errorCount}
        totalErrorCount={totalErrorCount}
        onFixErrorClick={onFixErrorClick}
      />
      <BulkUploadSuccessState
        successCount={successCount} // Pass the successCount state
        handleAddUsersClick={handleAddUsersClick} // Pass the handleAddUsersClick function
      />
    </div>
  );
};

export default BulkUserUploadState;
